module.exports = __webpack_public_path__ + "img/u108.4291391.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u108.png
// module id = j56c
// module chunks = 0